import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function ShareIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 18 19" {...props} style={{ fill: "none" }}>
      <path
        d="M5.8469 7.91675H4.38537C3.57818 7.91675 2.92383 8.5711 2.92383 9.37829V15.1635C2.92383 15.9707 3.57818 16.6251 4.38537 16.6251H13.1546C13.9618 16.6251 14.6161 15.9707 14.6161 15.1635V9.37829C14.6161 8.5711 13.9618 7.91675 13.1546 7.91675H11.6931"
        stroke="currentColor"
        strokeWidth="1.09615"
        strokeLinecap="round"
      />
      <path
        d="M8.76908 12.2708V1.58325M8.76908 1.58325L5.11523 4.74992M8.76908 1.58325L12.4229 4.74992"
        stroke="currentColor"
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
